import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { Check, Loader2 } from 'lucide-react';
import { Button } from './ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);
  const hasPolled = useRef(false);
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!sessionId || hasPolled.current) return;
    hasPolled.current = true;

    const poll = async (attempt = 0) => {
      if (attempt >= 5) {
        setStatus('timeout');
        return;
      }
      try {
        const token = localStorage.getItem('auth_token');
        const res = await axios.get(`${API}/api/payments/status/${sessionId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.payment_status === 'paid') {
          setStatus('paid');
          await checkAuth(); // Refresh user data with new plan
          return;
        }
        if (res.data.status === 'expired') {
          setStatus('expired');
          return;
        }
      } catch {}
      setAttempts(attempt + 1);
      setTimeout(() => poll(attempt + 1), 2000);
    };

    poll();
  }, [sessionId, checkAuth]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        {status === 'checking' && (
          <>
            <Loader2 className="w-12 h-12 text-blue-400 animate-spin mx-auto mb-4" />
            <h1 className="text-2xl font-bold mb-2">Verificando pago...</h1>
            <p className="text-muted-foreground">Confirmando tu transaccion con Stripe</p>
          </>
        )}
        {status === 'paid' && (
          <>
            <div className="w-16 h-16 rounded-full bg-emerald-500/20 flex items-center justify-center mx-auto mb-4">
              <Check className="w-8 h-8 text-emerald-400" />
            </div>
            <h1 className="text-2xl font-bold mb-2">Pago exitoso</h1>
            <p className="text-muted-foreground mb-6">Tu compra ha sido procesada exitosamente. Ya puedes usar Baluad.</p>
            <Button onClick={() => navigate('/app')} className="bg-gradient-to-r from-blue-500 to-cyan-500" data-testid="go-to-app-btn">
              Ir a la App
            </Button>
          </>
        )}
        {status === 'timeout' && (
          <>
            <h1 className="text-2xl font-bold mb-2">Verificacion en proceso</h1>
            <p className="text-muted-foreground mb-6">El pago esta siendo procesado. Tu plan se activara en unos minutos.</p>
            <Button onClick={() => navigate('/app')} variant="outline">Ir a la App</Button>
          </>
        )}
        {status === 'expired' && (
          <>
            <h1 className="text-2xl font-bold mb-2">Sesion expirada</h1>
            <p className="text-muted-foreground mb-6">La sesion de pago expiro. Intenta de nuevo.</p>
            <Button onClick={() => navigate('/pricing')} variant="outline">Ver Planes</Button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
